import { mountApplications } from '../../../../wikis/show.js?vue3';

mountApplications();
